import './PlanTitle.scss';

import { CaretDown, CaretUp } from '@phosphor-icons/react';
import {
  OperatorLogo,
  ProductOffering,
  ProductOfferingOrderType,
} from '@travelwin/core';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { PlanData } from '../PlanCard/components/PlanData';
import { Price } from '../PlanCard/components/Price';
import EllipsisTooltip from './component/EllipsisTooltip';

const className = 'c-PlanTitle';

type PlanTitleProps = {
  planDetails: ProductOffering;
  planType: ProductOfferingOrderType;
  showSubtitle: boolean;
  expandable?: boolean;
  expanded?: boolean;
  showOnlyPrice?: boolean;
};

export const PlanTitle = ({
  planDetails,
  planType,
  showSubtitle,
  expandable,
  expanded,
  showOnlyPrice = false,
}: PlanTitleProps) => {
  const { t } = useTranslation(['ecommerce']);
  const { data } = planDetails;
  const currencyAlias = planDetails.product_offering_pricing[0].currency.alias;
  const price = planDetails.product_offering_pricing[0].total_price_gross;

  return (
    <div className={className}>
      <div className={`${className}__title`}>
        <div className={`${className}__operator-icon`}>
          <OperatorLogo name={planDetails.icon_uri} />
        </div>
        <div className={`${className}__name`}>
          <div
            className={classNames(`${className}__plan-name`, {
              [`${className}__plan-name--featured`]: planType === 'featured',
            })}
          >
            {planDetails.name}
          </div>
          <div className={`${className}__operator-name`}>
            {planDetails.mvno.description}
          </div>
        </div>
      </div>

      {showSubtitle ? (
        <div className={`${className}__subtitle`}>
          <div
            className={classNames(`${className}__subtitle-left`, {
              [`${className}__subtitle-left--small-font`]:
                data === -1 || showOnlyPrice,
            })}
          >
            {showOnlyPrice ? (
              <Price currencyAlias={currencyAlias} price={price} />
            ) : (
              <EllipsisTooltip
                maxWidth="192px"
                popupInnerText={t('landing.plan.unlimited', 'Unlimited')}
              >
                <PlanData data={data} />
              </EllipsisTooltip>
            )}
          </div>
          {!showOnlyPrice && (
            <div
              className={`${className}__subtitle-right`}
              data-testid="div-plan-price"
            >
              <Price currencyAlias={currencyAlias} price={price} />
            </div>
          )}
        </div>
      ) : null}

      {expandable && (
        <div className={`${className}__expandable`}>
          {expanded
            ? t('plan_card.expandable.hide', 'Hide Plan Details')
            : t('plan_card.expandable.view', 'View Plan Details')}
          {expanded ? (
            <CaretUp size={24} className={`${className}__caret`} />
          ) : (
            <CaretDown size={24} className={`${className}__caret`} />
          )}
        </div>
      )}
    </div>
  );
};
